import { useAdminSession } from "../context/AdminSessionContext";
import { hasPermission, type PermissionCode } from "../utils/permissionHelpers";

export function usePermissionCheck(required?: PermissionCode) {
  const state = useAdminSession();
  const allowed =
    !!state.session && (!required || hasPermission(state.session.permissions, required));
  return { loading: state.loading, allowed };
}
